import {call, put, takeLatest, select} from 'redux-saga/effects'
import {initialize} from 'redux-form'
import i18n from '../../i18n'
import {downloadDocument} from '../../util/util'
import actionTypes from '../../constants/actions/importarClientesExcel/importarClientesExcel'
import {submitImportarClientesExcelSuccess} from '../../actions/importarClientesExcel/importarClientesExcel'
import {openModal, closeModal, openSimpleModal, openMensajeAlerta} from '../../actions/common'
import { yesNoModal } from '../modal/yesNoModal'
import getImportarClientesExcel from '../../services/importarClientesExcel/getImportarClientesExcel'
import getDescargarPlantillaExcelClientesExcel from '../../services/importarClientesExcel/getDescargarPlantillaExcelClientesExcel'

export function * submitImportarClientesExcel ({value}) {
  try {
    let auth = yield select(state => state.auth)
    const listCargaIndex = yield call(getImportarClientesExcel, value, auth.token)    
    yield put(submitImportarClientesExcelSuccess(listCargaIndex))
  } catch (error) {
    console.log(error)
  } finally {
    /*yield put(commonActions.hideLoader())*/
  }
}
export function * watchSubmitImportarClientesExcel () {
  yield takeLatest(actionTypes.SUBMIT_IMPORTAR_CLIENTES_EXCEL, submitImportarClientesExcel)
}

export function * descargarPlantillaExcelClientesExcel () {
  try {
    const archivoExcel = yield call(getDescargarPlantillaExcelClientesExcel, null)
    let href = 'data:application/csv;base64,' + encodeURIComponent(archivoExcel.xls)
    let name = i18n.t('IMPORTAR_CLIENTES_EXCEL.EJEMPLO_EXCEL_CLIENTES') + ".xlsx"
    downloadDocument(href, name)
  } catch (error) {
    console.log(error)
  } finally {
  }
}
export function * watchDescargarPlantillaExcelClientesExcel () {
  yield takeLatest(actionTypes.DESCARGAR_PLANTILLA_EXCEL_CLIENTES_EXCEL, descargarPlantillaExcelClientesExcel)
}